import React, { useEffect, useState } from "react";
import apiClient from "../../utils/apiClient";
import { formatDateTimestamp } from "../../utils/date";
import { useNavigate } from "react-router-dom";
import CustomIconButton from "../custom/CustomIconButton";
import VisibilityIcon from '@mui/icons-material/Visibility';
import CustomDataGrid from "../custom/CustomDataGrid";

export default function UserUpdateRequestData() {
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);

  const navigate = useNavigate();

  const handleViewChanges = (requestId, userId) => {
    navigate(`/update-confirmation/${requestId}/${userId}`);
  };

  useEffect(() => {
    apiClient
      .get("/users/request?status=pending")
      .then((response) => {
        setRows(
          response.data.data.map((request, index) => ({
            id: index + 1 + (page - 1) * 10,
            namaLengkap: request.user.nama_lengkap,
            universitas: request.user.institusi_asal,
            provinsi: request.user.provinsi_institusi,
            jenjang: request.user.jenjang,
            requestedAt: formatDateTimestamp(request.requested_at),
            userId: request.user.uuid,
            requestId: request.request_id,
          }))
        );
      })
      .catch((error) => {
        console.error("Error fetching institutions", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [page, refresh]);

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <CustomDataGrid
        rows={rows}
        loading={loading}
        columns={[
          { field: "id", headerName: "No.", flex: 1 },
          { field: "namaLengkap", headerName: "Nama Lengkap", flex: 1 },
          { field: "universitas", headerName: "Universitas", flex: 1 },
          { field: "provinsi", headerName: "Provinsi", flex: 1 },
          { field: "jenjang", headerName: "Jenjang", flex: 1 },
          { field: "requestedAt", headerName: "Waktu Request", flex: 1 },
          {
            field: "viewChanges",
            headerName: "View Changes",
            flex: 1,
            renderCell: (cellValues) => (
              <CustomIconButton
                baseColor="#003158"
                hoverColor="#00213A"
                tooltipText="Lihat Perubahan"
                icon={<VisibilityIcon sx={{ color: "WHITE" }} />}
                onClick={() =>
                  handleViewChanges(
                    cellValues.row.requestId,
                    cellValues.row.userId
                  )
                }
              />
            ),
          },
        ]}
        setPage={setPage}
      />
    </div>
  );
}
